/** Teks sub-bagian "Eksperimen suara" (#62) di "Gaya & aturan Jenna". */
export type VoiceExperimentKey =
	| "voiceFillerEnabled"
	| "voiceEchoFilterEnabled"
	| "voiceOpenerEnabled"
	| "voiceStyleLayerEnabled";

export interface AssistantVoiceExperimentsText {
	title: string;
	description: string;
	items: Record<VoiceExperimentKey, { label: string; hint: string }>;
	/** Bunyi napas tetap diatur di kartu "Bunyi tunggu"; di sini hanya pengingat. */
	waitSoundNote: string;
}

const id: AssistantVoiceExperimentsText = {
	title: "Eksperimen suara",
	description:
		"Fitur tambahan mode suara yang bawaannya MATI (= perilaku MVP). Nyalakan satu per satu sambil mengukur jeda; berlaku di sesi suara berikutnya, tanpa deploy.",
	items: {
		voiceFillerEnabled: {
			label: "Kata pengisi GPT-Live",
			hint: "GPT-Live mengucap salah satu kalimat tunggu (daftar di atas) saat menunggu jawaban, dan tampil sebagai baris “Jenna: …”.",
		},
		voiceEchoFilterEnabled: {
			label: "Filter gema",
			hint: "Mengabaikan ucapan mikrofon yang mirip kalimat Jenna yang sedang terdengar. Mati: hanya kata ragu (emm/hmm) dan ucapan tanpa isi yang disaring.",
		},
		voiceOpenerEnabled: {
			label: "Kalimat pembuka sebelum tool",
			hint: "Claude menulis satu kalimat pembuka sebelum mengambil data, dan kalimat itu ikut tersimpan.",
		},
		voiceStyleLayerEnabled: {
			label: "Gaya bicara & kata ekspresif (suara)",
			hint: "Memakai gaya suara dan kata ekspresif di giliran suara. Mati: prompt suara seperti MVP; gaya ketik tidak terpengaruh.",
		},
	},
	waitSoundNote:
		"Bunyi napas (tunggu) juga eksperimen dan bawaannya mati — atur di kartu “Bunyi tunggu” di bawah.",
};

const en: AssistantVoiceExperimentsText = {
	title: "Voice experiments",
	description:
		"Extra voice-mode features that are OFF by default (= MVP behaviour). Turn them on one at a time while measuring the delay; they apply to the next voice session, no deploy needed.",
	items: {
		voiceFillerEnabled: {
			label: "GPT-Live filler words",
			hint: "GPT-Live says one of the waiting sentences (list above) while waiting for the answer, shown as a “Jenna: …” line.",
		},
		voiceEchoFilterEnabled: {
			label: "Echo filter",
			hint: "Ignores microphone speech that resembles the sentence Jenna is currently speaking. Off: only hesitation sounds (emm/hmm) and empty utterances are filtered.",
		},
		voiceOpenerEnabled: {
			label: "Opener sentence before tools",
			hint: "Claude writes one opener sentence before fetching data, and it is saved with the answer.",
		},
		voiceStyleLayerEnabled: {
			label: "Speaking style & expressive words (voice)",
			hint: "Applies the voice style and expressive words in voice turns. Off: the voice prompt is the MVP one; the chat style is unaffected.",
		},
	},
	waitSoundNote:
		"The breathing (waiting) sound is also an experiment and is off by default — set it in the “Waiting sound” card below.",
};

export const assistantVoiceExperimentsTexts = { id, en } as const;
